export enum LOCAL_STORAGE {
  USER_CONTEXT = 'user_ctx',
  INSTITUTION_CODE = 'institution_code',
  TEACHER_TOKEN = 'teacher_token',
}

export class LocalStorageManager {
  static set(name: string, value: string | number | boolean | object): void {
    const stringValue =
      typeof value === 'string' ? value : JSON.stringify(value);

    localStorage.setItem(name, stringValue);
  }

  static get(name: string): string | undefined {
    return localStorage.getItem(name) || undefined;
  }

  static getParsed<T = unknown>(name: string): T | undefined {
    const raw = localStorage.getItem(name);
    if (!raw) return undefined;

    try {
      return JSON.parse(raw);
    } catch {
      return undefined;
    }
  }

  static delete(name: string): void {
    localStorage.removeItem(name);
  }

  static clear(): void {
    localStorage.clear();
  }
}
